import { DagreLayout } from '@antv/layout/lib/layout/dagre';

export default DagreLayout;
